export type FindNewTab = 'company' | 'contact';

export const TAB_STORAGE_KEY = 'findNew.tab';

export const readStoredTab = (): FindNewTab => {
  const stored = localStorage.getItem(TAB_STORAGE_KEY);
  return stored === 'company' || stored === 'contact' ? stored : 'contact';
};
